<template>
  <SectionPrice class="mb-5" :data="crmDataPrice">
    <template #title>
      <div v-if="title" class="font-bold text-center text-xl lg:text-2xl">
        {{ title }}
      </div>
    </template>
    <div class="flex flex-col justify-between h-full">
      <div class="text-center text-xs">{{ crmDataPrice.slot.sal }}</div>
      <span
        class="flex items-center justify-center mt-4"
        :class="{ 'line-through': crmDataPrice.offPrice }"
      >
        <span>از</span>
        <span :class="crmDataPrice.offPrice ? '' : 'mx-1 text-xl font-bold'">{{
          crmDataPrice.slot.price
        }}</span>
        <span>تومان</span>
      </span>
      <span
        v-if="crmDataPrice.offPrice"
        class="flex items-center justify-center font-bold"
      >
        <span class="mx-1 text-xl">{{ crmDataPrice.offPrice }}</span>
        <span>تومان</span>
      </span>
      <div class="flex items-center mt-6">
        <BaseButton
          isLean
          size="full"
          class="text-xs"
          :text="crmDataPrice.slot.btnOrder"
          @click="showMainModal"
        />
      </div>
    </div>
  </SectionPrice>
</template>

<script setup>
defineProps({
  title: String,
});

const crmDataPrice = {
  id: 1,
  label: "اتصال به سی آر ام",
  subTitle: "راه‌اندازی و اتصال مرکز تلفن ابری نواتل به سی آر ام",
  desc: "",
  options: [
    {
      id: "1",
      text: "هزینه اتصال سی آر ام به مرکز تلفن نواتل شامل هزینه راه‌اندازی اولیه و تعداد کاربرین استفاده کننده از سی آر ام است.",
    },
  ],
  slot: {
    sal: "سالیانه ",
    price: "6/480/000  ",
    btnOrder: "ثبت سفارش",
    // btnBuy: "خرید آنلاین ",
  },
  // off: "20",
  // offPrice: "3/600/000",
};

const modalsStore = useModalsStore();

const showMainModal = () => {
  modalsStore.openModal('CTA');
};
</script>
